import { render, staticRenderFns } from "./ProjectHeaderNew.vue?vue&type=template&id=d9915b22&scoped=true"
import script from "./ProjectHeaderNew.vue?vue&type=script&lang=ts"
export * from "./ProjectHeaderNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectHeaderNew.vue?vue&type=style&index=0&id=d9915b22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9915b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9915b22')) {
      api.createRecord('d9915b22', component.options)
    } else {
      api.reload('d9915b22', component.options)
    }
    module.hot.accept("./ProjectHeaderNew.vue?vue&type=template&id=d9915b22&scoped=true", function () {
      api.rerender('d9915b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectHeaderNew.vue"
export default component.exports